import { render, staticRenderFns } from "./ShopDataRecord.vue?vue&type=template&id=1f0a253a&scoped=true"
import script from "./ShopDataRecord.vue?vue&type=script&lang=js"
export * from "./ShopDataRecord.vue?vue&type=script&lang=js"
import style0 from "./ShopDataRecord.vue?vue&type=style&index=0&id=1f0a253a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a253a",
  null
  
)

export default component.exports